import styled from 'styled-components';
import IMask from 'imask';

import { SeturInputProps } from '@components/Input';

import { FormattedInputWrapper } from './common';

const YEAR = new Date().getFullYear();

const dateBlocks = (maxYear?: number) => ({
  YYYY: {
    mask: IMask.MaskedRange,
    from: 1900,
    to: maxYear || YEAR,
  },
  MM: {
    mask: IMask.MaskedRange,
    from: 1,
    to: 12,
  },
  DD: {
    mask: IMask.MaskedRange,
    from: 1,
    to: 31,
  },
});

const Input = styled.input.attrs({ inputMode: 'numeric' })`
  &:focus {
    top: 8px;
  }
`;

export const DateInput = ({
  placeholder = 'Doğum Tarihi(GG/AA/YYYY)',
  maxYear,
  ...rest
}: SeturInputProps & {
  date?: string;
  placeHolder?: string;
  maxYear?: number;
}) => {
  return (
    <FormattedInputWrapper
      mask='DD/MM/YYYY'
      blocks={dateBlocks(maxYear)}
      unmask={false}
      name='date'
      placeholder={placeholder}
      type='text'
      InputComponent={Input}
      forwardValue={rest.value}
      forwardDefaultValue={rest.defaultValue}
      {...rest}
    />
  );
};

export default DateInput;
